import { render, staticRenderFns } from "./GroceryProductRetailers.vue?vue&type=template&id=3cf22d0c&scoped=true&"
import script from "./GroceryProductRetailers.vue?vue&type=script&lang=js&"
export * from "./GroceryProductRetailers.vue?vue&type=script&lang=js&"
import style0 from "./GroceryProductRetailers.vue?vue&type=style&index=0&id=3cf22d0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf22d0c",
  null
  
)

export default component.exports